import { optionTitle_undoSend } from './UndoSendOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let UndoSendOption: LazyOption = createLazyOption(
    {
        key: 'undoSend',
        titleStringKey: optionTitle_undoSend,
        searchTermsStringKey: optionTitle_undoSend,
    },
    lazyFullModule,
    m => m.default
);
export default UndoSendOption;
